import { Component } from '@angular/core';
import { ROUTES } from './side-nav-routes.config';
import { ThemeConstantService } from '../../services/theme-constant.service';
import { MenuStateService } from '../../services/menu-state.service';
import { StoreService } from '../../services/store.service';

@Component({
    selector: 'app-sidenav',
    templateUrl: './side-nav.component.html'
})

export class SideNavComponent{

    public menuItems: any[]
    isFolded : boolean;
    isSideNavDark : boolean;
    isExpand : boolean;
    itemConditions: { [key: string]: boolean } = {};

    fullImageUrl: string;


    constructor( private themeService: ThemeConstantService, private stateService: MenuStateService, private storeService : StoreService) {}

    ngOnInit(): void {
        this.menuItems = ROUTES.filter(menuItem => menuItem);
        this.themeService.isMenuFoldedChanges.subscribe(isFolded => this.isFolded = isFolded);
        this.themeService.isExpandChanges.subscribe(isExpand => this.isExpand = isExpand);
        this.themeService.isSideNavDarkChanges.subscribe(isDark => this.isSideNavDark = isDark);
        this.stateService.itemConditions$.subscribe(conditions => {
            this.itemConditions = conditions;
            // console.log(this.itemConditions);
          });

          this.storeService.clientConfig$.subscribe(config => {
            if (config) {
              this.fullImageUrl = config.FullImageURL;
            }
          });


    }

    closeMobileMenu(): void {
        if (window.innerWidth < 992) {
            this.isFolded = false;
            this.isExpand = !this.isExpand;
            this.themeService.toggleExpand(this.isExpand);
            this.themeService.toggleFold(this.isFolded);
        }
    }
}
